export const brandColors = {
  'brand-hoop': '#3553e3',
  'on-brand-hoop': '#ffffff',
};
